import { httpGet, httpDelete, httpPut, httpPost } from "../http-requests";

const URL = '/api/map';

export async function getMapPointers() {
    const response = await httpGet(`${URL}`);
    return response.status === 200 ? response.data : [];
}

export async function putMapPointer(mapPointer, token) {
    const response = await httpPut(`${URL}/${mapPointer.id}`, token, mapPointer);
    return response;
}

export async function deleteMapPointer(mapPointer, token) {
    const response = await httpDelete(`${URL}/${mapPointer.id}`, token, )
    return response;
}

export async function postMapPointer(mapPointer, token) {
    const response = await httpPost(URL, token, mapPointer);
    return response;
}